import React from "react";
import "./index.less";
import img2 from "@/assets/img/img2.jpg";

const Page3: React.FC = () => {
  return (
    <section className="page3">
      <div className="info">
        {/* <div className="title">雅致环境</div> */}
        <div className="text">
          食材選びに妥協はなく、旬と産地にこだわり抜いた素材のみを厳選。ひとつひとつの素材に秘められた本来の旨みを最大限に引き出す“鮮味”の追求こそが、私たちの料理づくりの原点です。
        </div>
      </div>
      <div className="img">
        <img src={img2} alt="" />
      </div>
    </section>
  );
};

export default Page3;
